import { Tag as InternalBadge } from '@lessonnine/design-system.lib'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const Badge = {
  [DS_VERSIONS.default]: InternalBadge,
}

export default Badge[CURRENT_DS_VERSION]
